export { distanceToSlideOnTouchMove } from 'src/components/templates/CatalogPage/services/sliderServices';
import {
  ITouchActionX,
  ISliderInfo,
  getSlideTouchCheck,
  getPagePositionCheck,
} from 'src/components/templates/CatalogPage/services/sliderServices';

export const currentPageXPosition = (page: number, slideWidth = 0) => {
  switch (page) {
    case 1:
      return -slideWidth;
    case 2:
      return slideWidth;
    case 3:
      return slideWidth;
    default:
      return 2 * slideWidth;
  }
};

export const shouldGoTo = (
  touch: ITouchActionX,
  slider: ISliderInfo,
  sliderWidth: number,
) => {
  const { isNextPageSlideTouch, isPreviousPageSlideTouch, isTap } =
    getSlideTouchCheck(touch, sliderWidth);
  const { isLastPage, isFirstPage } = getPagePositionCheck(slider);

  if (isTap) {
    return 'zoomMode';
  } else if (isNextPageSlideTouch && !isLastPage) {
    return 'nextPage';
  } else if (isPreviousPageSlideTouch && !isFirstPage) {
    return 'previousPage';
  } else {
    return 'currentPage';
  }
};
